(() => {
  if (window.CromaImageLoading) return;
  window.CromaImageLoading = true;

  // Only theme-owned media frames; do not decorate app images or logos.
  const selector = '.croma-product-card__image, .croma-collection-card__image, .croma-resource-card__image, .croma-text-image__image, .croma-image-banner__image, .croma-hero__image, .croma-hero-slideshow__image, .croma-main-product__image, .croma-vertical-collections__image, .croma-main-cart__item-image, .croma-popup__image, .croma-cart-drawer__item-image';
  const states = new Map();
  const clear = (image) => {
    const state = states.get(image);
    image.classList.remove('croma-image-pending-media', 'croma-image-loaded');
    if (!state) return;
    state.controller.abort();
    state.frame.classList.remove('croma-image-pending');
    states.delete(image);
  };

  const prepare = (image) => {
    if (states.has(image) || !image.isConnected) return;
    image.decoding = 'async';
    // Critical and cached images stay visible immediately, without a JS reveal gate.
    if (image.loading !== 'lazy' || image.complete) return;
    const frame = image.parentElement?.tagName === 'PICTURE'
      ? image.parentElement.parentElement : image.parentElement;
    if (!frame || frame.querySelectorAll('img').length !== 1) return;
    const controller = new AbortController();
    const state = { frame, controller };
    states.set(image, state);
    frame.classList.add('croma-image-pending');
    image.classList.add('croma-image-pending-media');
    const finish = async (failed = false) => {
      if (!failed && image.decode) {
        try { await image.decode(); } catch { /* Keep native image/error fallback visible. */ }
      }
      if (controller.signal.aborted || states.get(image) !== state) return;
      frame.classList.remove('croma-image-pending');
      image.classList.remove('croma-image-pending-media');
      // Image reveal already owns its animation; avoid stacking a second one.
      if (!failed && image.naturalWidth && !image.closest('croma-image-reveal[data-reveal]')) {
        image.classList.add('croma-image-loaded');
      }
      controller.abort();
      states.delete(image);
    };
    image.addEventListener('load', () => finish(), { signal: controller.signal, once: true });
    image.addEventListener('error', () => finish(true), { signal: controller.signal, once: true });
    if (image.complete) finish(!image.naturalWidth);
  };
  const scan = (root) => {
    if (root.nodeType !== 1 && root !== document) return;
    if (root.matches?.(selector)) prepare(root);
    root.querySelectorAll(selector).forEach(prepare);
  };
  scan(document);
  new MutationObserver((records) => {
    for (const record of records) {
      if (record.type === 'attributes' && record.target.matches(selector)) {
        clear(record.target);
        prepare(record.target);
      } else if (record.type === 'attributes' && record.target.tagName === 'SOURCE') {
        const image = record.target.parentElement?.querySelector('img');
        if (image?.matches(selector)) { clear(image); prepare(image); }
      } else {
        record.addedNodes.forEach(scan);
      }
    }
    for (const image of states.keys()) if (!image.isConnected) clear(image);
  }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['src', 'srcset'] });
})();
